<template>
    <div>
        <h1>Company Codes</h1>
    </div>
</template>

<script>
    export default {
        name: 'CompanyCodes'
    };
</script>
